import React from 'react';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import DongleIcon from 'components/generic/components/DongleIcon';
import Styled from './EHerkenningCard.style';

const EHerkenningCard = () => {
  const theme = useTheme();

  return (
    <Styled theme={theme}>
      <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} alignItems="center" spacing={5}>
        <DongleIcon iconLabel={`Safenet`} />
        <img className="card-dongle-logo" src="/assets/images/card-logos/eherkenning.svg" alt="eherkenning" />
      </Stack>
    </Styled>
  );
};

export default EHerkenningCard;
